import { useEffect } from "react";
import { useNavigate } from "react-router";
import { consumePendingSsoDestination } from "src/services/loginEntry";

export const useSsoReturnDestination = (isAuthenticated: boolean) => {
    const navigate = useNavigate();

    useEffect(() => {
        if (isAuthenticated === false) return;

        const destination = consumePendingSsoDestination();
        if (destination === null) return;

        navigate(destination, { replace: true });
    }, [isAuthenticated, navigate]);
};
